import { jsx as _jsx } from "react/jsx-runtime";
import { useCategoryPageScroll } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageScroll";
import { CategoryPageFiltersAndContent } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/FiltersAndContent/CategoryPageFiltersAndContent";
import React from "react";
export var LoggedInCategoryPageContent = function(param) {
    var pageLoadTimingRef = param.pageLoadTimingRef, className = param.className;
    var _useCategoryPageScroll = useCategoryPageScroll(), scrollToTop = _useCategoryPageScroll.scrollToTop, scrollRef = _useCategoryPageScroll.scrollRef, filterRef = _useCategoryPageScroll.filterRef;
    return /*#__PURE__*/ _jsx(CategoryPageFiltersAndContent, {
        pageLoadTimingRef: pageLoadTimingRef,
        filterRef: filterRef,
        scrollRef: scrollRef,
        scrollToTop: scrollToTop,
        className: className
    });
};
